export const breadcrumbs = {
  "/": "Home",
  "/security": "Security",
  "/security/users": "Users",
  "/security/users/create": "Create",
  "/security/users/edit": "Edit",
  "/security/changepassword": "Change password",

  "/security/roles": "Roles",
  "/security/roles/create": "Create",
  "/security/roles/edit": "Edit",
  "/security/roles/permissions": "Permissions",

  "/admin": "Admin",
  "/admin/companies": "Companies",
  "/admin/companies/create": "Create",

  "/devices": "Device management",
  "/devices/licenses": "Licenses",
  "/devices/licenses/create": "Create",
  "/devices/licenses/history": "Renew history",

  "/devices/devices": "Devices",
  "/devices/devices/create": "Create",
  "/devices/devices/details": "Details",

  "/devices/coupons": "Coupons",
  "/devices/coupons/create": "Create",

  "/reports": "Reports",
  "/reports/licenseactivations": "License activations",
  "/reports/licensetransfers": "License transfers",
  "/reports/coupontransfers": "Coupon transfers",
};
